var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1030_10263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6837 14.4475C9.70901 14.5106 9.75301 14.5644 9.8098 14.6018C9.86658 14.6391 9.93344 14.6582 10.0014 14.6565C10.0693 14.6548 10.1351 14.6323 10.1899 14.5921C10.2447 14.5518 10.2859 14.4958 10.308 14.4315L14.6384 1.77327C14.6597 1.71424 14.6638 1.65036 14.6501 1.5891C14.6365 1.52784 14.6057 1.47173 14.5613 1.42735C14.5169 1.38297 14.4608 1.35215 14.3995 1.33849C14.3383 1.32483 14.2744 1.3289 14.2154 1.35022L1.55709 5.68068C1.49279 5.70273 1.43678 5.74392 1.39657 5.79872C1.35636 5.85352 1.33388 5.9193 1.33214 5.98725C1.3304 6.0552 1.34949 6.12205 1.38684 6.17884C1.42419 6.23562 1.47802 6.27962 1.5411 6.30493L6.82426 8.42353C6.99127 8.4904 7.14302 8.59039 7.27034 8.71749C7.39767 8.84458 7.49793 8.99615 7.5651 9.16304L9.6837 14.4475Z",
    stroke: "white",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.56 1.43018L7.27148 8.71801",
    stroke: "white",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1030_10263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.9fa0a3010eb6469c529acdff24424772.svg";
export { ForwardRef as ReactComponent };